/**
 * Central contact constants for Forklift Solutions booking/quote emails.
 * Update here if official FSL addresses change.
 */

export const BRAND_NAME = 'Forklift Solutions'
export const SUPPORT_PHONE = '0800 653 343'
export const SUPPORT_PHONE_TEL = '0800653343'

/** Postmark From address (verified sender domain) */
export const MAIL_FROM = 'noreply@accesssolutions.co.nz'

/** Quote / general company inbox (brief: existing info@accesssolutions.co.nz) */
export const QUOTE_COMPANY_EMAIL = 'info@accesssolutions.co.nz'
export const BOOKING_INFO_EMAIL = 'info@accesssolutions.co.nz'

/** Fallback when hire location is unknown */
export const BOOKING_FALLBACK_EMAIL = BOOKING_INFO_EMAIL

export const BOOKING_REGION_EMAILS = {
  Auckland: 'aukhire@accesssolutions.co.nz',
  Waikato: 'waihire@accesssolutions.co.nz',
  Christchurch: 'chrhire@accesssolutions.co.nz',
}

/** Company booking notice: regional hire inbox only (not info@). Customer gets a separate copy. */
export function bookingCompanyRecipients(location) {
  return BOOKING_REGION_EMAILS[location] || BOOKING_FALLBACK_EMAIL
}

export function bookingRegionalEmail(location) {
  return BOOKING_REGION_EMAILS[location] || BOOKING_INFO_EMAIL
}
